import {
  FormFieldTypes,
  IBaseFormField,
} from "@presentation/FormBuilder/components/FormFieldSelector/interfaces";
import { FieldProps } from "./FormFieldSelector/interfaces";
import {
  IFormFieldSubmission,
  IFieldSubmissionMap,
  IFormSubmission,
  IWorkflowServer,
  IFieldInputscript,
  ILoadFormCustomScript,
  IFormSubmissionCustomScript,
  IFormSubmissionMap,
  Events,
  IRespondedBySubmissionMap,
} from "@common/redux/formSubmission/interface";
import { IFieldLevelRuleConditionServer } from "@presentation/FormBuilder/components/ConfiguredRule/interface";
import {
  datePickerBasicData,
  datePickerAdvancedData,
  datetimePickerBasicData,
  datetimePickerAdvancedData,
  checkboxFieldBasicData,
  checkboxFieldAdvancedData,
  currencyFieldBasicData,
  currencyFieldAdvancedData,
  dropDownBasicData,
  dropDownAdvancedData,
  fileUploadFieldBasicData,
  fileUploadFieldAdvancedData,
  linearScaleBasicData,
  linearScaleAdvancedData,
  multichoiceBasicData,
  multichoiceAdvancedData,
  ratingFieldBasicData,
  ratingFieldAdvancedData,
  multiLineBasicData,
  multiLineAdvancedData,
  singleLineBasicData,
  singleLineAdvancedData,
  timePickerBasicData,
  timePickerAdvancedData,
  numberInputAdvancedData,
  numberInputBasicData,
  lookupFieldBasicData,
  lookupFieldAdvancedData,
  tableFieldBasicData,
  tableFieldAdvancedData,
  sequenceBasicData,
  sequenceAdvancedData,
  pincodeBasicData,
  pincodeAdvancedData,
  formLinkFieldBasicData,
  formLinkAdvancedData,
  yearSelectorBasicData,
  yearSelectorAdvancedData,
  timeSlotBasicData,
  timeSlotAdvancedData,
  buttonBasicData,
  buttonAdvancedData,
  bannerBasicdata,
  bannerAdvancedData,
  geoLocationFieldBasicData,
  geoLocationFieldAdvancedData,
  signatureFieldBasicData,
  signatureFieldAdvancedData,
  doublePanelBasicData,
  doublePanelAdvancedData,
  captchaBasicData,
  captchaAdvancedData,
  linkedDropdownBasicData,
  linkedDropdownAdvancedData,
  descriptionRichText,
  descriptionRichTextAdvancedData,
} from "@presentation/FormBuilder/components/fieldPropertiesUtils";
import {
  IAdvancedRulesServer,
  IForm,
  IFormLevelRuleServer,
  IPageLevelRuleServer,
  IPageToHIdeAndShow,
  ISubmissionLevelRuleServer,
  IFieldsToHIdeAndShow,
} from "@common/redux/formBuilder/interface";
import {
  logicalSwitchOption,
  validateFieldRuleValue,
} from "@presentation/FormBuilder/components/FieldLevelRule/utils";
import { IFieldLevelRuleServer } from "@common/redux/formBuilder/interface";
import {
  IFieldLevelRuleConditionClient,
  IFormLevelRuleActionServer,
  ISetRuleValueActionFieldTypeServer,
  ISubmissionLevelRuleActionServer,
} from "@common/redux/forms/interface";
import { ConditionType, defaultFormFieldData } from "../utils";
import { stringToExecutableFunction } from "./DynamicOptionsSetup/utils";
import { transformFieldSubmissionValuesClientToServer } from "@common/redux/formSubmission/utils";
import _ from "lodash";
import { IProfileMap } from "@common/redux/profile/interface";
import { IAttribute } from "@common/redux/admin/interface";
export interface ICommonFieldMapperData {
  fieldType: string;
  label: string;
  isFloatingLabel?: boolean;
}

export enum commonFieldMapperData {
  title = "title",
  name = "name",
  description = "description",
  isRequired = "isRequired",
  isDuplicateAllowed = "isDuplicateAllowed",
  isPII = "isPII",
  isMaskingEnabled = "isMaskingEnabled",
  isVisible = "isVisible",
  isDisabled = "isDisabled",
  fieldSize = "fieldSize",
  placeholder = "placeholder",
  initialValue = "initialValue",
  separator = "separator",
  decimal = "decimal",
  baseCurrency = "baseCurrency",
  fromNumberFieldId = "fromNumberFieldId",
  toNumberFieldId = "toNumberFieldId",
  isNegative = "isNegative",
  options = "options",
  sort = "sort",
  alignDirection = "alignDirection",
  selectedType = "selectedType",
  upperLimit = "upperLimit",
  writeJavascript = "writeJavascript",
  dateFormat = "dateFormat",
  lowerScale = "lowerScale",
  upperScale = "upperScale",
  lowerScaleLabel = "lowerScaleLable",
  upperScaleLabel = "upperScaleLabel",
  isSpecificFileType = "isSpecificFileType",
  isImageViewEnable = "isImageViewEnable",
  isLogoUpload = "isLogoUpload",
  maxNumFiles = "maxNumFiles",
  imageHeight = "imageHeight",
  imageWidth = "imageWidth",
  maxFileSize = "maxFileSize",
  selectedFileTypes = "selectedFileTypes",
  maxNumberAllowed = "maxNumberAllowed",
  minNumberAllowed = "minNumberAllowed",
  isNegativeAllowed = "isNegativeAllowed",
  fetchIpAddress = "fetchIpAddress",
  isDecimal = "isDecimal",
  dynamicOptionsSetup = "dynamicOptionsSetup",
  enableFieldRules = "enableFieldRules",
  sourceForm = "sourceForm",
  canAdd = "canAdd",
  canDelete = "canDelete",
  minRow = "minRow",
  maxRow = "maxRow",
  defaultHeight = "defaultHeight",
  rowCount = "rowCount",
  referenceLookUp = "referenceLookUp",
  isRelationshipExist = "isRelationshipExist",
  initialValueWithAccessKey = "initialValueWithAccessKey",
  sourceField = "sourceField",
  displayType = "displayType",
  selectionType = "selectionType",
  sortBy = "sortBy",
  inclusion = "inclusion",
  isDataGridDuplicateDisabled = "isDataGridDuplicateDisabled",
  isDataGridLookUpDuplicateDisabledByRows = "isDataGridLookUpDuplicateDisabledByRows",
  dataGridLookupDuplicateDisabledRowByField = "dataGridLookupDuplicateDisabledRowByField",
  filters = "filters",
  lookupFilter = "lookupFilter",
  prefix = "prefix",
  postfix = "postfix",
  state = "state",
  district = "district",
  country = "country",
  placename = "placename",
  taluk = "taluk",
  isAutoFetch = "isAutoFetch",
  eyeIcon = "eyeIcon",
  completeEncrypt = "completeEncrypt",
  maskChar = "maskChar",
  maxCharacter = "maxCharacter",
  maskedIndexes = "maskedIndexes",
  maskedField = "maskedField",
  showVirtualKeyboard = "showVirtualKeyboard",
  formLinkId = "formLinkId",
  isEditResponse = "isEditResponse",
  addResponseLabel = "addResponseLabel",
  editResponseLabel = "editResponseLabel",
  sequenceType = "sequenceType",
  hideFromVisiblity = "hideFromVisiblity",
  generateSequenceByWorkflow = "generateSequenceByWorkflow",
  numericSequenceCount = "numericSequenceCount",
  isRoundedNumber = "isRoundedNumber",
  configureDecimal = "configureDecimal",
  isIncrDecrEnabled = "isIncrDecrEnabled",
  incrDecrType = "incrDecrType",
  noOfVisibleYears = "noOfVisibleYears",
  initialValueYear = "initialValueYear",
  initialValueYearType = "initialValueYearType",
  noOfHidingYearsFromCurrentYear = "noOfHidingYearsFromCurrentYear",
  defaultYearVisible = "defaultYearVisible",
  isMultipleSelection = "isMultipleSelection",
  isRefrenceToCurrentForm = "isRefrenceToCurrentForm",
  enableMappingInEditMode = "enableMappingInEditMode",
  isPreSelectedValueRequired = "isPreSelectedValueRequired",
  dateRangeEnabled = "dateRangeEnabled",
  isWeekendDisabled = "isWeekendDisabled",
  specificDateSelectionEnabled = "specificDateSelectionEnabled",
  specificDateRangeEnabled = "specificDateRangeEnabled",
  jsonApiEnabled = "jsonApiEnabled",
  preDisableDateCount = "preDisableDateCount",
  postDisableDateCount = "postDisableDateCount",
  specificDates = "specificDates",
  specificDateRange = "specificDateRange",
  dateJsonApiUrl = "dateJsonApiUrl",
  slotDuration = "slotDuration",
  slotSetting = "slotSetting",
  dateReferralFieldId = "dateReferralFieldId",
  isPartOfTimeSlot = "isPartOfTimeSlot",
  buttonStyles = "buttonStyles",
  buttonText = "buttonText",
  backgroundEffect = "backgroundEffect",
  backgroundStroke = "backgroundStroke",
  buttonAction = "buttonAction",
  bannerTabValue = "bannerTabValue",
  bannerText = "bannerText",
  textConfigurations = "textConfigurations",
  image = "image",
  geolocationType = "geolocationType",
  locationInputPermission = "locationInputPermission",
  autoInputPermission = "autoInputPermission",
  locationDisplayType = "locationDisplayType",
  locationPlaceHolder = "locationPlaceHolder",
  signatureType = "signatureType",
  canvasHeight = "canvasHeight",
  canvasColor = "canvasColor",
  manualSignature = "manualSignature",
  eSign = "eSign",
  leftPanelConfiguration = "leftPanelConfiguration",
  rightPanelConfiguration = "rightPanelConfiguration",
  isShowCountEnabled = "isShowCountEnabled",
  panelName = "panelName",
  panelOptions = "panelOptions",
  numberOfOptionsRequired = "numberOfOptionsRequired",
  panelDropdownOptions = "panelDropdownOptions",
  isCurrentDateSelected = "isCurrentDateSelected",
  dateInitialValueType = "dateInitialValueType",
  showAddSubmission = "showAddSubmission",
  isCurrentTimeSelected = "isCurrentTimeSelected",
  timeInitialValueType = "timeInitialValueType",
  isCurrentDateTimeSelected = "isCurrentDateTimeSelected",
  dateTimeInitialValueType = "dateTimeInitialValueType",
  isPastDateDisabled = "isPastDateDisabled",
  fromFieldId = "fromFieldId",
  toFieldId = "toFieldId",
  fromTimeFieldId = "fromTimeFieldId",
  toTimeFieldId = "toTimeFieldId",
  isRegularTimeFormat = "isRegularTimeFormat",
  isSubmissionCount = "isSubmissionCount",
  submissionCountForm = "submissionCountForm",
  captchadropdownOptions = "captchadropdownOptions",
  captchaResetTime = "captchaResetTime",
  captchabgColor = "captchabgColor",
  errorMessage = "errorMessage",
  toggleInitialValue = "toggleInitialValue",
  linkedValues = "linkedValues",
  isRichTextEnable = "isRichTextEnable",
  defaultSequenceValue = "defaultSequenceValue",
  descriptionFieldHeight = "descriptionFieldHeight",
  isApiTriggerOnClick = "isApiTriggerOnClick",
  isTimeOfDayRequired = "isTimeOfDayRequired",
  timeOfDayFieldId = "timeOfDayFieldId",
  isMonthDisplayRequired = "isMonthDisplayRequired",
  monthDisplayFieldId = "monthDisplayFieldId",
  timeOfDayConfig = "timeOfDayConfig",
}
export interface ICommonFieldMapper {
  title: ICommonFieldMapperData;
  formLinkId?: ICommonFieldMapperData;
  isEditResponse?: ICommonFieldMapperData;
  addResponseLabel?: ICommonFieldMapperData;
  editResponseLabel?: ICommonFieldMapperData;
  name: ICommonFieldMapperData;
  description: ICommonFieldMapperData;
  isRequired: ICommonFieldMapperData;
  isDuplicateAllowed: ICommonFieldMapperData;
  isPII: ICommonFieldMapperData;
  isMaskingEnabled: ICommonFieldMapperData;
  isVisible: ICommonFieldMapperData;
  isDisabled: ICommonFieldMapperData;
  fieldSize: ICommonFieldMapperData;
  placeholder?: ICommonFieldMapperData;
  initialValue: ICommonFieldMapperData;
  separator?: ICommonFieldMapperData;
  decimal?: ICommonFieldMapperData;
  baseCurrency?: ICommonFieldMapperData;
  fromNumberFieldId?: ICommonFieldMapperData;
  toNumberFieldId?: ICommonFieldMapperData;
  isNegative?: ICommonFieldMapperData;
  options?: ICommonFieldMapperData;
  sort?: ICommonFieldMapperData;
  alignDirection?: ICommonFieldMapperData;
  selectedType?: ICommonFieldMapperData;
  upperLimit?: ICommonFieldMapperData;
  writeJavascript?: ICommonFieldMapperData;
  dateFormat?: ICommonFieldMapperData;
  lowerScale?: ICommonFieldMapperData;
  upperScale?: ICommonFieldMapperData;
  lowerScaleLabel?: ICommonFieldMapperData;
  upperScaleLabel?: ICommonFieldMapperData;
  isSpecificFileType?: ICommonFieldMapperData;
  isImageViewEnable?: ICommonFieldMapperData;
  isLogoUpload?: ICommonFieldMapperData;
  maxNumFiles?: ICommonFieldMapperData;
  imageHeight?: ICommonFieldMapperData;
  imageWidth?: ICommonFieldMapperData;
  maxFileSize?: ICommonFieldMapperData;
  selectedFileTypes?: ICommonFieldMapperData;
  maxNumberAllowed?: ICommonFieldMapperData;
  minNumberAllowed?: ICommonFieldMapperData;
  isNegativeAllowed?: ICommonFieldMapperData;
  fetchIpAddress?: ICommonFieldMapperData;
  isDecimal?: ICommonFieldMapperData;
  dynamicOptionsSetup?: ICommonFieldMapperData;
  toggleInitialValue?: ICommonFieldMapperData;
  enableFieldRules?: ICommonFieldMapperData;
  sourceForm?: ICommonFieldMapperData;
  canAdd?: ICommonFieldMapperData;
  canDelete?: ICommonFieldMapperData;
  minRow?: ICommonFieldMapperData;
  maxRow?: ICommonFieldMapperData;
  defaultHeight?: ICommonFieldMapperData;
  rowCount?: ICommonFieldMapperData;
  referenceLookUp?: ICommonFieldMapperData;
  initialValueWithAccessKey?: ICommonFieldMapperData;
  sourceField?: ICommonFieldMapperData;
  displayType?: ICommonFieldMapperData;
  selectionType?: ICommonFieldMapperData;
  sortBy?: ICommonFieldMapperData;
  inclusion?: ICommonFieldMapperData;
  isDataGridDuplicateDisabled?: ICommonFieldMapperData;
  isDataGridLookUpDuplicateDisabledByRows?: ICommonFieldMapperData;
  dataGridLookupDuplicateDisabledRowByField?: ICommonFieldMapperData;
  filters?: ICommonFieldMapperData;
  lookupFilter?: ICommonFieldMapperData;
  descriptionType?: ICommonFieldMapperData;
  prefix?: ICommonFieldMapperData;
  postfix?: ICommonFieldMapperData;
  state?: ICommonFieldMapperData;
  district?: ICommonFieldMapperData;
  placename?: ICommonFieldMapperData;
  country?: ICommonFieldMapperData;
  taluk?: ICommonFieldMapperData;
  isAutoFetch?: ICommonFieldMapperData;
  eyeIcon?: ICommonFieldMapperData;
  completeEncrypt?: ICommonFieldMapperData;
  maskChar?: ICommonFieldMapperData;
  maxCharacter?: ICommonFieldMapperData;
  maskedIndexes?: ICommonFieldMapperData;
  maskedField?: ICommonFieldMapperData;
  showVirtualKeyboard?: ICommonFieldMapperData;
  sequenceType?: ICommonFieldMapperData;
  hideFromVisiblity?: ICommonFieldMapperData;
  generateSequenceByWorkflow?: ICommonFieldMapperData;
  numericSequenceCount?: ICommonFieldMapperData;
  isIncrDecrEnabled?: ICommonFieldMapperData;
  isRoundedNumber?: ICommonFieldMapperData;
  configureDecimal?: ICommonFieldMapperData;
  incrDecrType?: ICommonFieldMapperData;
  isMultipleSelection?: ICommonFieldMapperData;
  isRefrenceToCurrentForm?: ICommonFieldMapperData;
  enableMappingInEditMode?: ICommonFieldMapperData;
  isPreSelectedValueRequired?: ICommonFieldMapperData;
  noOfVisibleYears?: ICommonFieldMapperData;
  initialValueYear?: ICommonFieldMapperData;
  initialValueYearType?: ICommonFieldMapperData;
  defaultYearVisible?: ICommonFieldMapperData;
  dateRangeEnabled?: ICommonFieldMapperData;
  isWeekendDisabled?: ICommonFieldMapperData;
  specificDateSelectionEnabled?: ICommonFieldMapperData;
  specificDateRangeEnabled?: ICommonFieldMapperData;
  jsonApiEnabled?: ICommonFieldMapperData;
  preDisableDateCount?: ICommonFieldMapperData;
  postDisableDateCount?: ICommonFieldMapperData;
  showAddSubmission?: ICommonFieldMapperData;
  specificDates?: ICommonFieldMapperData;
  specificDateRange?: ICommonFieldMapperData;
  dateJsonApiUrl?: ICommonFieldMapperData;
  slotDuration?: ICommonFieldMapperData;
  slotSetting?: ICommonFieldMapperData;
  dateReferralFieldId?: ICommonFieldMapperData;
  isPartOfTimeSlot?: ICommonFieldMapperData;
  buttonStyles?: ICommonFieldMapperData;
  buttonText?: ICommonFieldMapperData;
  backgroundEffect?: ICommonFieldMapperData;
  backgroundStroke?: ICommonFieldMapperData;
  buttonAction?: ICommonFieldMapperData;
  bannerTabValue?: ICommonFieldMapperData;
  bannerText?: ICommonFieldMapperData;
  textConfigurations?: ICommonFieldMapperData;
  image?: ICommonFieldMapperData;
  geolocationType?: ICommonFieldMapperData;
  locationInputPermission?: ICommonFieldMapperData;
  locationPlaceHolder?: ICommonFieldMapperData;
  signatureType?: ICommonFieldMapperData;
  canvasHeight?: ICommonFieldMapperData;
  canvasColor?: ICommonFieldMapperData;
  manualSignature?: ICommonFieldMapperData;
  eSign?: ICommonFieldMapperData;
  leftPanelConfiguration?: ICommonFieldMapperData;
  rightPanelConfiguration?: ICommonFieldMapperData;
  isShowCountEnabled?: ICommonFieldMapperData;
  isCurrentDateSelected?: ICommonFieldMapperData;
  dateInitialValueType?: ICommonFieldMapperData;
  isCurrentTimeSelected?: ICommonFieldMapperData;
  timeInitialValueType?: ICommonFieldMapperData;
  isCurrentDateTimeSelected?: ICommonFieldMapperData;
  dateTimeInitialValueType?: ICommonFieldMapperData;
  noOfHidingYearsFromCurrentYear?: ICommonFieldMapperData;
  isPastDateDisabled?: ICommonFieldMapperData;
  fromFieldId?: ICommonFieldMapperData;
  toFieldId?: ICommonFieldMapperData;
  fromTimeFieldId?: ICommonFieldMapperData;
  toTimeFieldId?: ICommonFieldMapperData;
  isRegularTimeFormat?: ICommonFieldMapperData;
  isSubmissionCount?: ICommonFieldMapperData;
  submissionCountForm?: ICommonFieldMapperData;
  captchadropdownOptions?: ICommonFieldMapperData;
  captchaResetTime?: ICommonFieldMapperData;
  captchabgColor?: ICommonFieldMapperData;
  errorMessage?: ICommonFieldMapperData;
  linkedValues?: ICommonFieldMapperData;
  isRichTextEnable?: ICommonFieldMapperData;
  defaultSequenceValue?: ICommonFieldMapperData;
  descriptionFieldHeight?: ICommonFieldMapperData;
  isApiTriggerOnClick?: ICommonFieldMapperData;
  isTimeOfDayRequired?: ICommonFieldMapperData;
  timeOfDayFieldId?: ICommonFieldMapperData;
  isMonthDisplayRequired?: ICommonFieldMapperData;
  monthDisplayFieldId?: ICommonFieldMapperData;
  timeOfDayConfig?: ICommonFieldMapperData;
}
export const commonFieldMapper: ICommonFieldMapper = {
  title: {
    fieldType: "TEXT_INPUT",
    label: "Field Label",
    isFloatingLabel: true,
  },
  noOfVisibleYears: {
    fieldType: "TEXT_INPUT",
    label: "No of Visible Years",
    isFloatingLabel: true,
  },
  noOfHidingYearsFromCurrentYear: {
    fieldType: "TEXT_INPUT",
    label: "No of HIding Years From Current Year",
    isFloatingLabel: true,
  },
  defaultYearVisible: {
    fieldType: "TEXT_INPUT",
    label: "Default Year",
    isFloatingLabel: true,
  },
  formLinkId: {
    fieldType: "TEXT_INPUT",
    label: "Form Id",
    isFloatingLabel: true,
  },
  isMultipleSelection: {
    fieldType: "CHECK_BOX",
    label: "Allow Multiple Selection",
    isFloatingLabel: true,
  },
  isEditResponse: {
    fieldType: "CHECK_BOX",
    label: "Allow Edit Response",
    isFloatingLabel: true,
  },
  showAddSubmission: {
    fieldType: "CHECK_BOX",
    label: "Allow User To Add Submission",
    isFloatingLabel: true,
  },
  addResponseLabel: {
    fieldType: "TEXT_INPUT",
    label: "Add Response Label",
    isFloatingLabel: true,
  },
  editResponseLabel: {
    fieldType: "TEXT_INPUT",
    label: "Edit Response Label",
    isFloatingLabel: true,
  },
  initialValueYearType: {
    fieldType: "TEXT_INPUT",
    label: "Select Year",
    isFloatingLabel: true,
  },
  initialValueYear: {
    fieldType: "DROPDOWN",
    label: "Initial Value",
  },
  state: {
    fieldType: "DROPDOWN",
    label: "select",
  },
  district: {
    fieldType: "DROPDOWN",
    label: "select",
  },
  country: {
    fieldType: "DROPDOWN",
    label: "select",
  },
  placename: {
    fieldType: "DROPDOWN",
    label: "select",
  },
  taluk: {
    fieldType: "DROPDOWN",
    label: "select",
  },
  sourceForm: {
    fieldType: "DROPDOWN",
    label: "select",
  },
  name: {
    fieldType: "TEXT_INPUT",
    label: "Field Name",
    isFloatingLabel: true,
  },
  description: {
    fieldType: "TEXT_AREA",
    label: "Description",
    isFloatingLabel: true,
  },
  descriptionType: {
    fieldType: "DESCRIPTION_TYPE",
    label: "Description Type",
  },
  isRequired: {
    fieldType: "CHECK_BOX",
    label: "Required",
  },
  isAutoFetch: {
    fieldType: "CHECK_BOX",
    label: "isAutoFetch",
  },
  isDuplicateAllowed: {
    fieldType: "CHECK_BOX",
    label: "Allow Duplicate Value",
  },
  isRefrenceToCurrentForm: {
    fieldType: "CHECK_BOX",
    label: "Related to current form",
  },
  enableMappingInEditMode: {
    fieldType: "CHECK_BOX",
    label: "Enable Field Mapping in edit mode",
  },
  isPreSelectedValueRequired: {
    fieldType: "CHECK_BOX",
    label: "Initial Value Required",
  },
  isVisible: {
    fieldType: "CHECK_BOX",
    label: "Hide Field For Submission",
  },
  isPII: {
    fieldType: "CHECK_BOX",
    label: "Enable Encryption",
  },
  isMaskingEnabled: {
    fieldType: "CHECK_BOX",
    label: "Enable Masking",
  },
  isDisabled: {
    fieldType: "CHECK_BOX",
    label: "Disable Field For User",
  },
  fieldSize: {
    fieldType: "LINEAR_SCALING",
    label: "Field Size",
  },
  placeholder: {
    fieldType: "TEXT_INPUT",
    label: "Placeholder Text",
    isFloatingLabel: true,
  },
  initialValue: {
    fieldType: "TEXT_INPUT",
    label: "Initial Value",
    isFloatingLabel: true,
  },
  separator: {
    fieldType: "DROPDOWN",
    label: "Thousand Seperator",
  },
  decimal: {
    fieldType: "DROPDOWN",
    label: "Rounded To",
  },
  fromNumberFieldId: {
    fieldType: "DROPDOWN",
    label: "Min Value(Field)",
  },
  toNumberFieldId: {
    fieldType: "DROPDOWN",
    label: "Max Value(Field)",
  },
  baseCurrency: {
    fieldType: "DROPDOWN",
    label: "roundedTo",
  },
  isNegative: {
    fieldType: "CHECK_BOX",
    label: "Allow Negative Value",
  },
  options: {
    fieldType: "TEXT_INPUT",
    label: "choices",
    isFloatingLabel: true,
  },
  sort: {
    fieldType: "DROPDOWN",
    label: "sortBy",
  },
  alignDirection: {
    fieldType: "DROPDOWN",
    label: "displayFormat",
  },
  selectedType: {
    fieldType: "DROPDOWN",
    label: "displayFormat",
  },
  upperLimit: {
    fieldType: "DROPDOWN",
    label: "displayFormat",
  },
  writeJavascript: {
    fieldType: "CODE_EDITOR",
    label: "Write Javascript",
  },
  dateFormat: {
    fieldType: "DROPDOWN",
    label: "Date Format",
  },
  lowerScale: {
    fieldType: "NUMBER_INPUT",
    label: "Lower Scale Limit",
    isFloatingLabel: true,
  },
  upperScale: {
    fieldType: "NUMBER_INPUT",
    label: "Upper Scale Limit",
    isFloatingLabel: true,
  },
  lowerScaleLabel: {
    fieldType: "TEXT_INPUT",
    label: "Lower Scale Label",
    isFloatingLabel: true,
  },
  upperScaleLabel: {
    fieldType: "TEXT_INPUT",
    label: "Upper Scale Label",
    isFloatingLabel: true,
  },

  maxNumFiles: {
    fieldType: "NUMBER_INPUT",
    label: "Max number of files accepted",
    isFloatingLabel: true,
  },
  imageHeight: {
    fieldType: "NUMBER_INPUT",
    label: "Image height(in PX)",
    isFloatingLabel: true,
  },
  imageWidth: {
    fieldType: "NUMBER_INPUT",
    label: "Image Width(in PX)",
    isFloatingLabel: true,
  },
  maxFileSize: {
    fieldType: "NUMBER_INPUT",
    label: "Accepted File size(in MB)",
    isFloatingLabel: true,
  },
  isSpecificFileType: {
    fieldType: "ToGGLE",
    label: "isSpecificFileType",
  },
  isImageViewEnable: {
    fieldType: "ToGGLE",
    label: "isImageViewEnable",
  },
  isLogoUpload: {
    fieldType: "CHECK_BOX",
    label: "isLogoUpload",
  },

  selectedFileTypes: {
    fieldType: "CHECK_BOX",
    label: "selectedFileTypes",
  },
  isNegativeAllowed: {
    fieldType: "CHECK_BOX",
    label: "Allow Negative Numbers",
  },
  isDecimal: {
    fieldType: "CHECK_BOX",
    label: "Allow Decimal Numbers",
  },
  maxNumberAllowed: {
    fieldType: "NUMBER_INPUT",
    label: "Maximum Number Allowed",
    isFloatingLabel: true,
  },
  minNumberAllowed: {
    fieldType: "NUMBER_INPUT",
    label: "Minimum Number Allowed",
    isFloatingLabel: true,
  },
  dynamicOptionsSetup: {
    // have to check and remove
    fieldType: "CHECK_BOX",
    label: "Enable Dynamic Options",
  },
  toggleInitialValue: {
    // have to check and remove
    fieldType: "Toggle",
    label: "Enable Initial value",
  },
  enableFieldRules: {
    fieldType: "CHECK_BOX",
    label: "Enable Field Validation",
  },
  canAdd: {
    fieldType: "CHECK_BOX",
    label: "Can Add Row",
  },
  canDelete: {
    fieldType: "CHECK_BOX",
    label: "Can Delete Row",
  },
  minRow: {
    fieldType: "NUMBER_INPUT",
    label: "Minimun Row Allowed",
    isFloatingLabel: true,
  },
  maxRow: {
    fieldType: "NUMBER_INPUT",
    label: "Maximum Row Allowed",
    isFloatingLabel: true,
  },
  defaultHeight: {
    fieldType: "NUMBER_INPUT",
    label: "Default Table Height",
    isFloatingLabel: true,
  },
  rowCount: {
    fieldType: "NUMBER_INPUT",
    label: "Row Count",
    isFloatingLabel: true,
  },
  referenceLookUp: {
    fieldType: "DROPDOWN",
    label: "select",
  },
  initialValueWithAccessKey: {
    fieldType: "DROPDOWN",
    label: "select",
  },
  sourceField: {
    fieldType: "DROPDOWN",
    label: "select",
  },
  displayType: {
    fieldType: "CHECK_BOX",
    label: "displayType",
  },
  selectionType: {
    fieldType: "CHECK_BOX",
    label: "displayType",
  },
  sortBy: {
    fieldType: "CHECK_BOX",
    label: "displayType",
  },
  inclusion: {
    fieldType: "CHECK_BOX",
    label: "displayType",
  },
  isDataGridDuplicateDisabled: {
    fieldType: "CHECK_BOX",
    label: "Duplicate Disabled",
  },
  isDataGridLookUpDuplicateDisabledByRows: {
    fieldType: "CHECK_BOX",
    label: "Duplicate Disabled By rows",
  },
  dataGridLookupDuplicateDisabledRowByField: {
    fieldType: "DROPDOWN",
    label: "Select Column Field",
  },
  filters: {
    fieldType: "CHECK_BOX",
    label: "displayType",
  },
  lookupFilter: {
    fieldType: "CHECK_BOX",
    label: "displayType",
  },
  prefix: {
    fieldType: "TEXT_INPUT",
    label: "Prefix",
    isFloatingLabel: true,
  },
  postfix: {
    fieldType: "TEXT_INPUT",
    label: "Postfix",
    isFloatingLabel: true,
  },
  eyeIcon: {
    fieldType: "CHECK_BOX",
    label: "EyeIcon Visible Data",
  },
  completeEncrypt: {
    fieldType: "CHECK_BOX",
    label: "Show virtual keyboard",
  },
  maskedField: {
    fieldType: "MASK_FIELD",
    label: "Mask Field",
    isFloatingLabel: true,
  },
  showVirtualKeyboard: {
    fieldType: "CHECK_BOX",
    label: "Show virtual keyboard",
  },
  sequenceType: {
    fieldType: "DROPDOWN",
    label: "select",
  },
  hideFromVisiblity: {
    fieldType: "CHECK_BOX",
    label: "select",
  },
  generateSequenceByWorkflow: {
    fieldType: "CHECK_BOX",
    label: "select",
  },
  numericSequenceCount: {
    fieldType: "TEXT_INPUT",
    label: "Numeric Sequence Count",
    isFloatingLabel: true,
  },
  defaultSequenceValue: {
    fieldType: "TEXT_INPUT",
    label: "Numeric Initial Sequence Count",
    isFloatingLabel: true,
  },
  isRoundedNumber: {
    fieldType: "CHECK_BOX",
    label: "RoundOff Number",
  },
  configureDecimal: {
    fieldType: "NUMBER_INPUT",
    label: "Decimal Precision",
  },

  isIncrDecrEnabled: {
    fieldType: "TOGGLE",
    label: "Increment and Decrement Notations",
  },
  isSubmissionCount: {
    fieldType: "TOGGLE",
    label: "Submission Count As Value",
  },
  submissionCountForm: {
    fieldType: "TOGGLE",
    label: "Submission Count Form",
  },
  incrDecrType: {
    fieldType: "CHECK_BOX",
    label: "Type",
  },
  dateRangeEnabled: {
    fieldType: "CHECK_BOX",
    label: "Enable Date Range",
  },
  isWeekendDisabled: {
    fieldType: "CHECK_BOX",
    label: "Disable Weekend",
  },
  specificDateSelectionEnabled: {
    fieldType: "CHECK_BOX",
    label: "Disable Specific Date Selection",
  },
  specificDateRangeEnabled: {
    fieldType: "CHECK_BOX",
    label: "Enable Specific Date Range",
  },
  jsonApiEnabled: {
    fieldType: "CHECK_BOX",
    label: "Enable Json Api",
  },
  preDisableDateCount: {
    fieldType: "TEXT_INPUT",
    label: "- days",
  },
  postDisableDateCount: {
    fieldType: "TEXT_INPUT",
    label: "+ days",
  },

  specificDates: {
    fieldType: "TEXT_INPUT",
    label: "SpecificDates",
  },

  specificDateRange: {
    fieldType: "TEXT_INPUT",
    label: "specificDateRange",
  },

  dateJsonApiUrl: {
    fieldType: "TEXT_INPUT",
    label: "dateJsonApiUrl",
  },
  slotDuration: {
    fieldType: "DROPDOWN",
    label: "slot duration",
  },
  slotSetting: {
    fieldType: "TEXT_INPUT",
    label: "slot setting",
  },
  dateReferralFieldId: {
    fieldType: "DROPDOWN",
    label: "Date Field",
  },
  isPartOfTimeSlot: {
    fieldType: "CHECK_BOX",
    label: "Is Part Of Time Slot",
  },
  isPastDateDisabled: {
    fieldType: "CHECK_BOX",
    label: "Is Past Date Disabled",
  },
  fromFieldId: {
    fieldType: "DROPDOWN",
    label: "From Date",
  },
  toFieldId: {
    fieldType: "DROPDOWN",
    label: "From Date",
  },
  fromTimeFieldId: {
    fieldType: "DROPDOWN",
    label: "From Time",
  },
  toTimeFieldId: {
    fieldType: "DROPDOWN",
    label: "To Time",
  },
  isRegularTimeFormat: {
    fieldType: "CHECK_BOX",
    label: "am-pm Format",
  },
  buttonStyles: {
    fieldType: "CHECK_BOX",
    label: "Text Configuration",
  },
  buttonText: {
    fieldType: "BUTTON_TEXT",
    label: "Button Text",
  },
  backgroundEffect: {
    fieldType: "CHECK_BOX",
    label: "Text Configuration",
  },
  backgroundStroke: {
    fieldType: "CHECK_BOX",
    label: "Text Configuration",
  },
  buttonAction: {
    fieldType: "DROPDOWN",
    label: "redirect to new url",
  },
  bannerTabValue: {
    fieldType: "bannerTabValue",
    label: "Text",
  },
  image: {
    fieldType: "CHECK_BOX",
    label: "Text Configuration",
  },
  bannerText: {
    fieldType: "TEXT_INPUT",
    label: "Text",
  },
  textConfigurations: {
    fieldType: "CHECK_BOX",
    label: "Text Configuration",
  },
  geolocationType: {
    fieldType: "CHECK_BOX",
    label: "is Manual add Type",
  },

  locationInputPermission: {
    fieldType: "CHECK_BOX",
    label: "location input type permission",
  },

  locationPlaceHolder: {
    fieldType: "TEXT_INPUT",
    label: "Initial Value",
    isFloatingLabel: true,
  },

  signatureType: {
    fieldType: "CHECK_BOX",
    label: "is Manual Signature Type",
  },
  canvasColor: {
    fieldType: "TEXT_INPUT",
    label: "Canvas Color setting",
  },
  canvasHeight: {
    fieldType: "NUMBER_INPUT",
    label: "Canvas Height",
  },
  manualSignature: {
    fieldType: "TEXT_INPUT",
    label: "Manual Signature Value",
  },
  eSign: {
    fieldType: "TEXT_INPUT",
    label: "eSign",
  },
  isShowCountEnabled: {
    fieldType: "TOGGLE",
    label: "Show Count",
  },
  leftPanelConfiguration: {
    fieldType: "DROPDOWN",
    label: "roundedTo",
  },
  rightPanelConfiguration: {
    fieldType: "DROPDOWN",
    label: "roundedTo",
  },
  isCurrentDateSelected: {
    fieldType: "CHECK_BOX",
    label: "Initial Date Selected",
  },
  dateInitialValueType: {
    fieldType: "DROPDOWN",
    label: "Date Initial Value Type",
  },
  isCurrentTimeSelected: {
    fieldType: "CHECK_BOX",
    label: "Initial Date Selected",
  },
  timeInitialValueType: {
    fieldType: "DROPDOWN",
    label: "Date Initial Value Type",
  },
  isCurrentDateTimeSelected: {
    fieldType: "CHECK_BOX",
    label: "Initial Date Selected",
  },
  dateTimeInitialValueType: {
    fieldType: "DROPDOWN",
    label: "Date Initial Value Type",
  },
  captchadropdownOptions: {
    fieldType: "DROPDOWN",
    label: "Text based",
  },
  captchaResetTime: {
    fieldType: "DROPDOWN",
    label: "10",
  },
  captchabgColor: {
    fieldType: "ColorSelectorHexa",
    label: "#1D1929",
  },
  errorMessage: {
    fieldType: "TEXT_INPUT",
    label: "enter error message",
  },
  linkedValues: {
    fieldType: "DROPDOWN",
    label: "linked Dropdown Data",
  },
  isRichTextEnable: {
    fieldType: "DESCRIPTION",
    label: "rich text ",
  },
  descriptionFieldHeight: {
    fieldType: "deescription",
    label: "description field height",
    isFloatingLabel: true,
  },
  isApiTriggerOnClick: {
    fieldType: "CHECK_BOX",
    label: "Trigger API On Click",
  },
  isTimeOfDayRequired: {
    fieldType: "CHECK_BOX",
    label: "Time Of Day Is Required",
  },
  timeOfDayFieldId: {
    fieldType: "DROPDOWN",
    label: "Select a field to display the time of day",
  },
  isMonthDisplayRequired: {
    fieldType: "CHECK_BOX",
    label: "Month Display Is Required",
  },
  monthDisplayFieldId: {
    fieldType: "DROPDOWN",
    label: "Select a field to display the month",
  },
  timeOfDayConfig: {
    fieldType: "TEXT_INPUT",
    label: "Add Time of Day Configuration",
  },
};
interface IFieldPropertideType {
  general: string[];
  advance: string[];
}
const getFieldSettingData = (
  generalData: string[],
  adavanceData: string[]
): IFieldPropertideType => {
  return {
    general: generalData,
    advance: adavanceData,
  };
};

export const getFieldProperties = (
  fieldType: FormFieldTypes
): IFieldPropertideType => {
  switch (fieldType) {
    case FormFieldTypes.TEXT_INPUT:
      return getFieldSettingData(singleLineBasicData, singleLineAdvancedData);
    case FormFieldTypes.DESCRIPTION:
      return getFieldSettingData(
        descriptionRichText,
        descriptionRichTextAdvancedData
      );
    case FormFieldTypes.FORM_LINK:
      return getFieldSettingData(formLinkFieldBasicData, formLinkAdvancedData);
    case FormFieldTypes.YEAR_SELECTOR:
      return getFieldSettingData(
        yearSelectorBasicData,
        yearSelectorAdvancedData
      );
    case FormFieldTypes.PIN_CODE:
      return getFieldSettingData(pincodeBasicData, pincodeAdvancedData);
    case FormFieldTypes.LOOKUP:
      return getFieldSettingData(lookupFieldBasicData, lookupFieldAdvancedData);
    case FormFieldTypes.NUMBER_INPUT:
      return getFieldSettingData(numberInputBasicData, numberInputAdvancedData);
    case FormFieldTypes.DATA_GRID:
      return getFieldSettingData(tableFieldBasicData, tableFieldAdvancedData);
    case FormFieldTypes.TEXT_AREA:
      return getFieldSettingData(multiLineBasicData, multiLineAdvancedData);
    case FormFieldTypes.DATE_INPUT:
      return getFieldSettingData(datePickerBasicData, datePickerAdvancedData);
    case FormFieldTypes.DATE_TIME_PICKER:
      return getFieldSettingData(
        datetimePickerBasicData,
        datetimePickerAdvancedData
      );
    case FormFieldTypes.TIME_PICKER:
      return getFieldSettingData(timePickerBasicData, timePickerAdvancedData);
    case FormFieldTypes.RATING:
      return getFieldSettingData(ratingFieldBasicData, ratingFieldAdvancedData);
    case FormFieldTypes.CHECK_BOX:
      return getFieldSettingData(
        checkboxFieldBasicData,
        checkboxFieldAdvancedData
      );
    case FormFieldTypes.LINEAR_SCALING:
      return getFieldSettingData(linearScaleBasicData, linearScaleAdvancedData);
    case FormFieldTypes.CURRENCY:
      return getFieldSettingData(
        currencyFieldBasicData,
        currencyFieldAdvancedData
      );
    case FormFieldTypes.FILE_UPLOAD:
      return getFieldSettingData(
        fileUploadFieldBasicData,
        fileUploadFieldAdvancedData
      );
    case FormFieldTypes.DROPDOWN:
      return getFieldSettingData(dropDownBasicData, dropDownAdvancedData);
    case FormFieldTypes.MULTIPLE_CHOICES:
      return getFieldSettingData(multichoiceBasicData, multichoiceAdvancedData);
    case FormFieldTypes.SEQUENCE:
      return getFieldSettingData(sequenceBasicData, sequenceAdvancedData);
    case FormFieldTypes.TIME_SLOT:
      return getFieldSettingData(timeSlotBasicData, timeSlotAdvancedData);
    case FormFieldTypes.BUTTON:
      return getFieldSettingData(buttonBasicData, buttonAdvancedData);
    case FormFieldTypes.BANNER:
      return getFieldSettingData(bannerBasicdata, bannerAdvancedData);
    case FormFieldTypes.GEOLOCATION:
      return getFieldSettingData(
        geoLocationFieldBasicData,
        geoLocationFieldAdvancedData
      );
    case FormFieldTypes.SIGNATURE_BOX:
      return getFieldSettingData(
        signatureFieldBasicData,
        signatureFieldAdvancedData
      );
    case FormFieldTypes.DOUBLE_PANEL:
      return getFieldSettingData(doublePanelBasicData, doublePanelAdvancedData);
    case FormFieldTypes.CAPTCHA:
      return getFieldSettingData(captchaBasicData, captchaAdvancedData);
    case FormFieldTypes.LINKED_DROPDOWN:
      return getFieldSettingData(
        linkedDropdownBasicData,
        linkedDropdownAdvancedData
      );
    default:
      break;
  }
};
export const onSaveFieldData = (
  currentFormFieldData: FieldProps,
  fieldData
) => {
  let updateCurrentFormFieldData = currentFormFieldData;
  const { settings: fieldSettings } = currentFormFieldData;
  Object.keys(fieldData).map(function (key, index) {
    if (["isVisible", "isDisabled"].includes(key)) {
      if (key == "isVisible") {
        const initialValueData = !fieldData[key]?.["initialValue"];
        updateCurrentFormFieldData = {
          ...updateCurrentFormFieldData,
          settings: {
            ...fieldSettings,
            visibility: {
              ...updateCurrentFormFieldData.settings.visibility,
              [key]: initialValueData ?? fieldData[key],
            },
          },
        };
      } else {
        updateCurrentFormFieldData = {
          ...updateCurrentFormFieldData,
          settings: {
            ...fieldSettings,
            visibility: {
              ...updateCurrentFormFieldData.settings.visibility,
              [key]: fieldData[key]?.["initialValue"] ?? fieldData[key],
            },
          },
        };
      }
    } else if (
      [
        "placeholder",
        "initialValue",
        "upperLimit",
        "writeJavascript",
        "dateFormat",
        "lowerScaleLabel",
        "upperScaleLabel",
        "separator",
        "decimal",
        "baseCurrency",
        "fromNumberFieldId",
        "toNumberFieldId",
        "isNegative",
        "isSpecificFileType",
        "isImageViewEnable",
        "isLogoUpload",
        "maxNumFiles",
        "imageHeight",
        "imageWidth",
        "maxFileSize",
        "selectedFileTypes",
        "options",
        "sort",
        "dynamicOptionsSetup",
        "toggleInitialValue",
        "selectedType",
        "alignDirection",
        "isNegativeAllowed",
        "isDecimal",
        "maxNumberAllowed",
        "minNumberAllowed",
        "referenceLookUp",
        "isRelationshipExist",
        "initialValueWithAccessKey",
        "sourceForm",
        "sourceField",
        "displayType",
        "selectionType",
        "sortBy",
        "inclusion",
        "isDataGridDuplicateDisabled",
        "isDataGridLookUpDuplicateDisabledByRows",
        "dataGridLookupDuplicateDisabledRowByField",
        "filters",
        "canAdd",
        "canDelete",
        "minRow",
        "maxRow",
        "defaultHeight",
        "rowCount",
        "prefix",
        "postfix",
        "state",
        "taluk",
        "placename",
        "district",
        "country",
        "isAutoFetch",
        "maskedField",
        "showVirtualKeyboard",
        "formLinkId",
        "isEditResponse",
        "addResponseLabel",
        "editResponseLabel",
        "sequenceType",
        "hideFromVisiblity",
        "generateSequenceByWorkflow",
        "numericSequenceCount",
        "defaultSequenceValue",
        "isIncrDecrEnabled",
        "isRoundedNumber",
        "configureDecimal",
        "incrDecrType",
        "isMultipleSelection",
        "isRefrenceToCurrentForm",
        "enableMappingInEditMode",
        "isPreSelectedValueRequired",
        "noOfVisibleYears",
        "initialValueYear",
        "initialValueYearType",
        "noOfHidingYearsFromCurrentYear",
        "defaultYearVisible",
        "lookupFilter",
        "dateRangeEnabled",
        "isWeekendDisabled",
        "specificDateSelectionEnabled",
        "specificDateRangeEnabled",
        "jsonApiEnabled",
        "preDisableDateCount",
        "postDisableDateCount",
        "specificDates",
        "specificDateRange",
        "dateJsonApiUrl",
        "slotDuration",
        "slotSetting",
        "dateReferralFieldId",
        // "availableDays",
        "isPartOfTimeSlot",
        "backgroundEffect",
        "backgroundStroke",
        "buttonStyles",
        "buttonText",
        "buttonAction",
        "bannerTabValue",
        "bannerText",
        "textConfigurations",
        "image",
        "geolocationType",
        "locationInputPermission",
        "locationPlaceHolder",
        "signatureType",
        "canvasHeight",
        "canvasColor",
        "manualSignature",
        "eSign",
        "leftPanelConfiguration",
        "rightPanelConfiguration",
        "isShowCountEnabled",
        "isCurrentDateSelected",
        "dateInitialValueType",
        "showAddSubmission",
        "isCurrentTimeSelected",
        "timeInitialValueType",
        "isCurrentDateTimeSelected",
        "dateTimeInitialValueType",
        "isPastDateDisabled",
        "fromFieldId",
        "toFieldId",
        "fromTimeFieldId",
        "toTimeFieldId",
        "isRegularTimeFormat",
        "isSubmissionCount",
        "submissionCountForm",
        "captchadropdownOptions",
        "captchaResetTime",
        "errorMessage",
        "captchabgColor",
        "imageBasedcaptchaType",
        "textBasedcaptchaType",
        "linkedValues",
        "isRichTextEnable",
        "descriptionFieldHeight",
        "isApiTriggerOnClick",
        "isTimeOfDayRequired",
        "timeOfDayFieldId",
        "isMonthDisplayRequired",
        "monthDisplayFieldId",
        "timeOfDayConfig",
      ].includes(key)
    ) {
      updateCurrentFormFieldData = {
        ...updateCurrentFormFieldData,
        fieldValue: {
          ...updateCurrentFormFieldData.fieldValue,
          [key]: fieldData[key]?.["initialValue"] ?? fieldData[key],
        },
      };
    } else if (["lowerScale", "upperScale"].includes(key)) {
      updateCurrentFormFieldData = {
        ...updateCurrentFormFieldData,
        fieldValue: {
          ...updateCurrentFormFieldData.fieldValue,
          [key]: fieldData[key]?.["initialValue"] ?? fieldData[key],
        },
      };
    } else if (["fieldSize"].includes(key)) {
      const updatedValue =
        fieldData["fieldSize"]?.["initialValue"]?.toString() ??
        fieldData["fieldSize"]?.toString();
      updateCurrentFormFieldData = {
        ...updateCurrentFormFieldData,
        grid: {
          ...updateCurrentFormFieldData.grid,
          width: eval(updatedValue),
        },
      };
    } else if (key === "enableFieldRules") {
      const updatedFieldRuleConfigs =
        fieldData["enableFieldRules"]?.["initialValue"]?.["fieldRuleConfigs"] ||
        currentFormFieldData.rules ||
        [];
      updateCurrentFormFieldData = {
        ...updateCurrentFormFieldData,
        rules: updatedFieldRuleConfigs,
      };
    } else {
      updateCurrentFormFieldData = {
        ...updateCurrentFormFieldData,
        [key]: fieldData[key]?.["initialValue"] ?? fieldData[key],
      };
    }
  });
  return updateCurrentFormFieldData;
};
export const valiDateFieldRule = (
  activeFieldRule: IFieldLevelRuleServer,
  fieldSubmissionMap: IFieldSubmissionMap,
  hiddenField: string[],
  profileMap?: IProfileMap,
  respondedByData?: IRespondedBySubmissionMap,
  organizationAtribututes?: IAttribute
): boolean => {
  const { logicalOperator, conditions } = activeFieldRule; // discuss and make loop or just single rule
  if (conditions && conditions.length == 0) {
    return true;
  }
  const checkFieldRule = (
    fieldRuleconditions: IFieldLevelRuleConditionServer[],
    parentLogicalOperator: string
  ): boolean => {
    const isORCondition =
      parentLogicalOperator?.toUpperCase?.() ===
      logicalSwitchOption.OR.toUpperCase();
    let isValidated = isORCondition;
    for (const index in fieldRuleconditions) {
      const fieldConditionData: IFieldLevelRuleConditionServer =
        fieldRuleconditions[index];
      if (hiddenField.includes(fieldConditionData?.fieldLocalId)) {
        isValidated = false;
        break;
      }
      const { logicalOperator } = fieldConditionData;
      // const updatedlogicalOperator =
      //   logicalOperator == null ? "or" : logicalOperator;
      if (logicalOperator) {
        const { conditions } = fieldConditionData;
        isValidated = checkFieldRule(conditions, logicalOperator);
      } else {
        const fieldValueIsValidated = validateFieldValue(
          fieldConditionData,
          fieldSubmissionMap,
          profileMap,
          respondedByData,
          organizationAtribututes
        );
        isValidated = fieldValueIsValidated;
        if (
          (isORCondition && fieldValueIsValidated) ||
          (!isORCondition && !fieldValueIsValidated)
        ) {
          break;
        }
      }
    }
    return isValidated;
  };
  return checkFieldRule(conditions, logicalOperator);
};
export const valiDatePageRule = (
  activePageRule: IPageLevelRuleServer,
  fieldSubmissionMap: IFieldSubmissionMap,
  hiddenPage: string[],
  visiblePage: string[],
  activeFormData: IForm,
  profileMap?: IProfileMap,
  respondedByData?: IRespondedBySubmissionMap
): {
  isValidated: boolean;
  updatedHiddenPage: string[];
  updatedVisiblePage: string[];
} => {
  const { logicalOperator = logicalSwitchOption.OR.toUpperCase(), conditions } =
    activePageRule; // discuss and make loop or just single rule
  let updatedHiddenPage = [...hiddenPage];
  let updatedVisiblePage = [...visiblePage];
  const checkPageRule = (
    fieldRuleconditions: IFieldLevelRuleConditionClient[],
    parentLogicalOperator: string
  ): boolean => {
    const isORCondition =
      parentLogicalOperator?.toUpperCase() ===
      logicalSwitchOption.OR.toUpperCase();

    let isValidated = isORCondition;
    for (const index in fieldRuleconditions) {
      const fieldConditionData: IFieldLevelRuleConditionClient =
        fieldRuleconditions[index];
      if (updatedHiddenPage?.includes(fieldConditionData?.fieldLocalId)) {
        //If fieldId is already hidden
        isValidated = false;
        break;
      }
      const conditions = fieldConditionData?.conditions || [];
      const { logicalOperator = logicalSwitchOption.OR.toUpperCase() } =
        fieldConditionData;
      if (logicalOperator && conditions.length > 0) {
        isValidated = checkPageRule(conditions, logicalOperator);
      } else {
        const fieldValueIsValidated = validateFieldValue(
          fieldConditionData,
          fieldSubmissionMap,
          profileMap,
          respondedByData
        );
        if (fieldValueIsValidated && (!isValidated || index == "0")) {
          const pageConditionData: IFieldLevelRuleConditionClient =
            activePageRule?.conditions[index];
          const skip = pageConditionData?.action?.skip ?? [];
          const show = pageConditionData?.action?.show ?? [];
          const hide = pageConditionData?.action?.hide ?? [];
          // const elseSkip = pageConditionData?.action?.elseSkip ?? [];
          const pageToSkip = skip.map((page) => page.subFormLocalId);
          const pageToHide = hide.map((page) => page.subFormLocalId);
          const pageToShow = show.map((page) => page.subFormLocalId);
          const conditionSubFormId = pageConditionData?.subFormLocalId || "";
          const skipTo = pageToSkip?.[0] || "";
          const stopIndex = activeFormData?.subForms?.indexOf(skipTo);
          if (stopIndex !== -1) {
            const startIndex =
              activeFormData?.subForms?.indexOf(conditionSubFormId) || 0;
            const resultArray = activeFormData?.subForms?.slice(
              startIndex + 1,
              stopIndex
            );
            updatedHiddenPage = [
              ...updatedHiddenPage,
              ...hiddenPage,
              ...resultArray,
              ...pageToHide,
            ];
            updatedVisiblePage = [...pageToShow];
          } else {
            updatedHiddenPage = [
              ...updatedHiddenPage,
              ...hiddenPage,
              ...pageToHide,
            ];
          }
        }
        if (fieldValueIsValidated) {
          const pageConditionData: IFieldLevelRuleConditionClient =
            activePageRule?.conditions[index];
          const elseSkip = pageConditionData?.action?.elseSkip ?? [];
          const pageToHide = elseSkip.map((page) => page.subFormLocalId);
          const hide = activePageRule?.action?.hide ?? [];
          const show = activePageRule?.action?.show ?? [];
          const updatedpageToHide = hide.map((page) => page.subFormLocalId);
          const pageToShow = show.map((page) => page.subFormLocalId);
          updatedHiddenPage = [
            ...updatedHiddenPage,
            ...hiddenPage,
            ...pageToHide,
            ...updatedpageToHide,
          ];
          const updateHiddenPageData = updatedHiddenPage.filter(
            (item) => !pageToShow.includes(item)
          );
          updatedHiddenPage = updateHiddenPageData;
        } else {
          const pageConditionData: IFieldLevelRuleConditionClient =
            activePageRule?.conditions[index];
          const show = pageConditionData?.action?.show || [];
          const pageToShow = show.map((page) => page.subFormLocalId);
          updatedHiddenPage = [
            ...updatedHiddenPage,
            ...hiddenPage,
            ...pageToShow,
          ];
        }

        isValidated = fieldValueIsValidated;
        if (
          (isORCondition && fieldValueIsValidated) ||
          (!isORCondition && !fieldValueIsValidated)
        ) {
          break;
        }
      }
    }
    return isValidated;
  };

  const isPageRuleValidated = checkPageRule(conditions, logicalOperator);

  return {
    isValidated: isPageRuleValidated,
    updatedHiddenPage: updatedHiddenPage,
    updatedVisiblePage: updatedVisiblePage,
  };
};

export const validateFormLevelRuleAndGetRedirectionPath = (
  formRules: IFormLevelRuleServer[],
  formSubmissionData: IFormSubmission,
  hiddenField: string[],
  profileMap?: IProfileMap,
  respondedByData?: IRespondedBySubmissionMap
) => {
  // discuss and make loop or just single rule
  const fieldSubmissionMap = formSubmissionData?.fieldSubmissionMap;

  const getActionByActionType = (array, targetType) => {
    for (const obj of array) {
      if (obj.actionType === targetType) {
        return obj;
      }
    }
    return null;
  };
  for (const index in formRules) {
    const formRuleData: IFormLevelRuleServer = formRules[index];
    const { logicalOperator, conditions } = formRuleData;
    const isValidated = checkFieldRuleConditions(
      conditions,
      logicalOperator,
      hiddenField,
      fieldSubmissionMap,
      profileMap,
      respondedByData
    );
    if (isValidated) {
      const formAction: IFormLevelRuleActionServer[] =
        formRuleData?.formAction || [];
      const redirectObject: IFormLevelRuleActionServer = getActionByActionType(
        formAction,
        "REDIRECT"
      );
      return redirectObject?.value;
    }
  }
  return "";
};

export const checkFieldRuleConditions = (
  formRuleconditions: IFieldLevelRuleConditionServer[],
  parentLogicalOperator: string,
  hiddenField: string[],
  fieldSubmissionMap: IFieldSubmissionMap,
  profileMap?: IProfileMap,
  respondedByData?: IRespondedBySubmissionMap
): boolean => {
  const isORCondition =
    parentLogicalOperator?.toUpperCase() ===
    logicalSwitchOption.OR.toUpperCase();
  let isValidated = isORCondition;
  for (const index in formRuleconditions) {
    const formConditionData: IFieldLevelRuleConditionServer =
      formRuleconditions[index];
    if (hiddenField.includes(formConditionData?.fieldLocalId)) {
      //If fieldId is already in
      isValidated = false;
      break;
    }
    const { logicalOperator } = formConditionData;
    if (logicalOperator) {
      const { conditions } = formConditionData;
      isValidated = checkFieldRuleConditions(
        conditions,
        logicalOperator,
        hiddenField,
        fieldSubmissionMap,
        profileMap,
        respondedByData
      );
    } else {
      const fieldValueIsValidated = validateFieldValue(
        formConditionData,
        fieldSubmissionMap
      );
      isValidated = fieldValueIsValidated;
      if (
        (isORCondition && fieldValueIsValidated) ||
        (!isORCondition && !fieldValueIsValidated)
      ) {
        break;
      }
    }
  }
  return isValidated;
};
export const isFieldId = (param) => {
  return typeof param === "string" && param.includes("_field_id_");
};

const getNormalizedValueFromSubmission = (
  fieldSubmission: IFormFieldSubmission
): any => {
  if (!fieldSubmission) return "";

  const { fieldSubmissionValue, fieldType } = fieldSubmission;

  switch (fieldType) {
    case FormFieldTypes?.DROPDOWN:
    case FormFieldTypes?.MULTIPLE_CHOICES:
      return (
        fieldSubmissionValue?.selectedOption ||
        fieldSubmissionValue?.selectedOptions
      );
    case FormFieldTypes?.CHECK_BOX:
      return fieldSubmissionValue?.checkBoxValue ?? "false";
    case FormFieldTypes?.LINEAR_SCALING:
    case FormFieldTypes?.RATING:
      return fieldSubmissionValue?.selectedOption + "";
    case FormFieldTypes?.FILE_UPLOAD:
      return fieldSubmissionValue?.uploadedFiles;
    case FormFieldTypes?.LOOKUP:
      if (Array.isArray(fieldSubmissionValue?.selectedOptions)) {
        return fieldSubmissionValue?.selectedOptions;
      } else if (typeof fieldSubmissionValue?.selectedOption === "object") {
        return (
          fieldSubmissionValue?.selectedOption?.optionValue ||
          fieldSubmissionValue?.selectedOption
        );
      } else if (typeof fieldSubmissionValue?.value === "string") {
        return fieldSubmissionValue?.value;
      }
      return "";
    default:
      return fieldSubmissionValue?.value;
  }
};
export const validateFieldValue = (
  fieldConditionData: IFieldLevelRuleConditionServer,
  fieldSubmissionMap: IFieldSubmissionMap,
  profileMap?: IProfileMap,
  respondedByData?: IRespondedBySubmissionMap,
  organizationAtribututes?: IAttribute
): boolean => {
  const {
    operator,
    value,
    fieldType,
    fieldLocalId,
    fieldValueType,
    conditionType,
  } = fieldConditionData;
  const submissionId = respondedByData && Object.keys(respondedByData)?.[0];
  let updatedValue: any = value;
  if (
    (fieldValueType && fieldValueType == ConditionType.form_field) ||
    isFieldId(value)
  ) {
    const fieldValueSubmissionData: IFormFieldSubmission =
      fieldSubmissionMap[value];
    const fieldValueSubmissionValue =
      fieldValueSubmissionData?.fieldSubmissionValue;
    const conditionValueFieldType = fieldValueSubmissionData?.fieldType;
    switch (conditionValueFieldType) {
      case FormFieldTypes?.DROPDOWN:
        if (fieldValueSubmissionValue?.selectedOption) {
          //selectedOption for single select
          updatedValue = fieldValueSubmissionValue?.selectedOption;
        }
        if (fieldValueSubmissionValue?.selectedOptions) {
          //selectedOptions for multi select
          updatedValue = fieldValueSubmissionValue?.selectedOptions;
        }
        break;
      case FormFieldTypes?.MULTIPLE_CHOICES:
        if (fieldValueSubmissionValue?.selectedOption) {
          //selectedOption for single select
          updatedValue = fieldValueSubmissionValue?.selectedOption;
        }
        if (fieldValueSubmissionValue?.selectedOptions) {
          //selectedOptions for multi select
          updatedValue = fieldValueSubmissionValue?.selectedOptions;
        }
        break;
      case FormFieldTypes?.LINEAR_SCALING:
        updatedValue = fieldValueSubmissionValue?.selectedOption + "";
        break;
      case FormFieldTypes?.FILE_UPLOAD:
        updatedValue = fieldValueSubmissionValue?.uploadedFiles;
        break;
      case FormFieldTypes?.RATING:
        updatedValue = fieldValueSubmissionValue?.selectedOption + "";
        break;
      default:
        updatedValue = fieldValueSubmissionValue?.value;

        break;
    }
  } else if (fieldValueType && fieldValueType == ConditionType.user_field) {
    const object = profileMap ? Object.keys(profileMap)?.[0] : "";
    if (value == "username") {
      updatedValue = profileMap?.[object]["name"];
    } else if (value == "phoneNumber") {
      updatedValue = profileMap?.[object]["mobile"];
    } else {
      updatedValue = profileMap?.[object][value];
    }
  } else if (
    fieldValueType &&
    fieldValueType == ConditionType.user_attributes
  ) {
    const userAtribute = value ?? "";
    updatedValue = organizationAtribututes?.[userAtribute]?.[0];
  } else if (
    fieldValueType &&
    (fieldValueType == ConditionType.system_fields ||
      fieldValueType == "system_field")
  ) {
    if (fieldLocalId == "createdBy") {
      updatedValue = respondedByData?.[submissionId]?.createdById;
    } else if (fieldLocalId == "lastUpdatedBy") {
      updatedValue = respondedByData?.[submissionId]?.id;
    } else if (fieldLocalId == "makerLevel") {
      updatedValue =
        respondedByData?.[submissionId]?.makerLevel?.toString() ?? "";
    } else if (fieldLocalId == "updaterLevel") {
      updatedValue =
        respondedByData?.[submissionId]?.updatedByLevel?.toString() ?? "";
    } else if (fieldLocalId == "makerEmail") {
      updatedValue = respondedByData?.[submissionId]?.makerEmail;
    } else if (fieldLocalId == "updaterEmail") {
      updatedValue = respondedByData?.[submissionId]?.updatedByEmail;
    }
  } else {
    updatedValue = value;
  }

  let fieldSubmissionData: IFormFieldSubmission =
    fieldSubmissionMap[fieldLocalId];
  if (!fieldSubmissionData) {
    for (const key in fieldSubmissionMap) {
      const field = fieldSubmissionMap[key];
      if (field?.fieldType === "DATA_GRID") {
        const dataGridValue = field?.fieldSubmissionValue?.dataGridValue;
        if (dataGridValue) {
          for (const dataKey in dataGridValue) {
            const dataRow = dataGridValue?.[dataKey];
            const nestedField = dataRow?.[fieldLocalId];
            if (nestedField) {
              fieldSubmissionData = nestedField;
              break;
            }
          }
        }
        if (fieldSubmissionData) break;
      }
    }
  }
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;
  // field-Wise validation start
  let submissionValue: any;
  switch (fieldType) {
    case FormFieldTypes?.DROPDOWN:
      if (fieldSubmissionValue?.selectedOption) {
        //selectedOption for single select
        submissionValue = fieldSubmissionValue?.selectedOption;
      }
      if (fieldSubmissionValue?.selectedOptions) {
        //selectedOptions for multi select
        submissionValue = fieldSubmissionValue?.selectedOptions;
      }
      break;
    case FormFieldTypes?.CHECK_BOX:
      submissionValue = fieldSubmissionValue?.checkBoxValue ?? "false";
      break;
    case FormFieldTypes?.MULTIPLE_CHOICES:
      if (fieldSubmissionValue?.selectedOption) {
        //selectedOption for single select
        submissionValue = fieldSubmissionValue?.selectedOption;
      }
      if (fieldSubmissionValue?.selectedOptions) {
        //selectedOptions for multi select
        submissionValue = fieldSubmissionValue?.selectedOptions;
      }
      break;
    case FormFieldTypes?.LINEAR_SCALING:
      submissionValue = fieldSubmissionValue?.selectedOption + "";
      break;
    case FormFieldTypes?.FILE_UPLOAD:
      submissionValue = fieldSubmissionValue?.uploadedFiles;
      break;
    case FormFieldTypes?.RATING:
      submissionValue = fieldSubmissionValue?.selectedOption + "";
      break;
    case FormFieldTypes?.LOOKUP:
      if (
        fieldSubmissionValue?.selectedOptions &&
        Array.isArray(fieldSubmissionValue?.selectedOptions)
      ) {
        submissionValue = fieldSubmissionValue?.selectedOptions;
      } else if (typeof fieldSubmissionValue?.selectedOption == "object") {
        submissionValue =
          fieldSubmissionValue?.selectedOption?.optionValue ||
          fieldSubmissionValue?.selectedOption;
      } else if (
        fieldSubmissionValue?.value &&
        typeof fieldSubmissionValue?.value == "string"
      ) {
        submissionValue = fieldSubmissionValue?.value;
      }
      break;
    default:
      submissionValue = fieldSubmissionValue?.value;
      break;
  }
  if (conditionType == ConditionType.user_field) {
    const object = Object.keys(profileMap)?.[0];
    if (value == "username") {
      submissionValue = profileMap?.[object]["name"];
    } else if (value == "phoneNumber") {
      submissionValue = profileMap?.[object]["mobile"];
    } else {
      submissionValue = profileMap?.[object][value];
    }
  } 
   else if (
    conditionType == ConditionType.system_fields ||
    conditionType == "system_field"
  ) {
    if (fieldLocalId == "createdBy") {
      submissionValue = respondedByData?.[submissionId]?.createdById;
    } else if (fieldLocalId == "lastUpdatedBy") {
      submissionValue = respondedByData?.[submissionId]?.id;
    } else if (fieldLocalId == "makerLevel") {
      submissionValue =
        respondedByData?.[submissionId]?.makerLevel?.toString() ?? "";
    } else if (fieldLocalId == "updaterLevel") {
      submissionValue =
        respondedByData?.[submissionId]?.updatedByLevel?.toString() ?? "";
    } else if (fieldLocalId == "makerEmail") {
      submissionValue = respondedByData?.[submissionId]?.makerEmail;
    } else if (fieldLocalId == "updaterEmail") {
      submissionValue = respondedByData?.[submissionId]?.updatedByEmail;
    }
  }
    
  const isValidated = validateFieldRuleValue(
    updatedValue,
    submissionValue || "",
    operator,
    "",
    fieldType
  );
  return isValidated;
};

export const getFieldsToHideAndShow = (
  formRule: IAdvancedRulesServer
): IFieldsToHIdeAndShow => {
  const fieldRules = formRule?.fieldRules;

  let hiddenField: string[] = [];
  let visibleField: string[] = [];

  for (const index in fieldRules) {
    const fieldConditionData: IFieldLevelRuleServer = fieldRules[index];
    const { action } = fieldConditionData;
    const hideField = action.hide ?? [];
    const showField = action.show ?? [];
    const fieldsToHide = hideField.map((field) => field.fieldLocalId);
    const fieldsToShow = showField.map((field) => field.fieldLocalId);
    hiddenField = [...hiddenField, ...fieldsToShow];
    visibleField = [...visibleField, ...fieldsToHide];
  }
  return {
    hide: hiddenField,
    show: visibleField,
  };
};
export interface IValidateFormRules {
  fieldsToHideAndShow: IFieldsToHIdeAndShow;
  pageToHideAndShow: IPageToHIdeAndShow;
  valuesToUpdate: ISetRuleValueActionFieldTypeServer[];
  submissionAction: ISubmissionLevelRuleActionServer;
}
export const valiDateFormRule = (
  formRule: IAdvancedRulesServer,
  fieldSubmissionMap: IFieldSubmissionMap,
  activeFormData: IForm,
  profileMap?: IProfileMap,
  respondedByData?: IRespondedBySubmissionMap
): IValidateFormRules => {
  const fieldRules = formRule?.fieldRules;
  const pageRules: IPageLevelRuleServer[] = formRule?.pageRules;
  const submissionRules: ISubmissionLevelRuleServer[] =
    formRule?.submissionRules;

  let hiddenField: string[] = [];
  let visibleField: string[] = [];
  let valuesToUpdate: ISetRuleValueActionFieldTypeServer[] = [];
  let disabledFields: string[] = [];
  let formSubmissionAction: ISubmissionLevelRuleActionServer = {};

  let hiddenPage: string[] = [];
  let visiblePage: string[] = [];

  for (const index in fieldRules) {
    const fieldConditionData: IFieldLevelRuleServer = fieldRules[index];
    const isValidated: boolean = valiDateFieldRule(
      fieldConditionData,
      fieldSubmissionMap,
      hiddenField,
      profileMap,
      respondedByData
    );
    const { action } = fieldConditionData;
    const hideField = action.hide ?? [];
    const showField = action.show ?? [];
    const setValue = action.setValue ?? [];
    const enable = action.enable ?? [];
    const disable = action.disable ?? [];
    const fieldsToHide = hideField.map((field) => field.fieldLocalId);
    const fieldsToshow = showField.map((field) => field.fieldLocalId);
    const fieldsToDisable = disable.map((field) => field.fieldLocalId);
    const fieldsToEnable = enable.map((field) => field.fieldLocalId);
    if (isValidated) {
      visibleField = [...visibleField, ...fieldsToshow]; // can be usedLater
      hiddenField = [...hiddenField, ...fieldsToHide];
      valuesToUpdate = [...valuesToUpdate, ...setValue];
      disabledFields = [...disabledFields, ...fieldsToDisable];
    } else {
      visibleField = [...visibleField, ...fieldsToHide]; // can be usedLater
      hiddenField = [...hiddenField, ...fieldsToshow];
      disabledFields = [...disabledFields, ...fieldsToEnable];
    }
  }
  for (const index in pageRules) {
    const pageConditionData: IPageLevelRuleServer = pageRules[index];
    const pageRuleValidationData = valiDatePageRule(
      pageConditionData,
      fieldSubmissionMap,
      hiddenPage,
      visiblePage,
      activeFormData,
      profileMap,
      respondedByData
    );
    const { isValidated, updatedHiddenPage, updatedVisiblePage } =
      pageRuleValidationData;
    const { action } = pageConditionData;
    const hide = action.hide ?? [];
    const showPage = action.show ?? [];
    const pageToHide = hide.map((page) => page.subFormLocalId);
    const pageToshow = showPage.map((page) => page.subFormLocalId);
    if (isValidated) {
      // const activeCondition = pageConditionData?.conditions?.[0];
      // const conditionSubFormId = activeCondition?.subFormLocalId || '';
      // const skipTo = pageToHide?.[0] || '';
      // const stopIndex = activeFormData?.subForms?.indexOf(skipTo);
      // const startIndex = activeFormData?.subForms?.indexOf(conditionSubFormId) || 0;
      // const resultArray = activeFormData?.subForms?.slice(startIndex + 1, stopIndex);
      hiddenPage = [...hiddenPage, ...updatedHiddenPage];
      visiblePage = [...updatedVisiblePage, ...pageToshow]; // can be usedLater
    } else {
      const activeCondition = pageConditionData?.conditions?.[0];
      const conditionSubFormId = activeCondition?.subFormLocalId || "";
      const ShowPage = pageToshow?.[0] || "";
      const stopIndex = activeFormData?.subForms?.indexOf(ShowPage);
      const startIndex =
        activeFormData?.subForms?.indexOf(conditionSubFormId) || 0;
      const resultArray = activeFormData?.subForms?.slice(
        startIndex + 1,
        stopIndex
      );
      visiblePage = [...visiblePage, ...pageToHide]; // can be usedLater
      hiddenPage = [...hiddenPage, ...resultArray];
    }
  }

  for (const index in submissionRules) {
    const submissionConditionData: ISubmissionLevelRuleServer =
      submissionRules[index];
    const isValidated: boolean = valiDateFieldRule(
      submissionConditionData,
      fieldSubmissionMap,
      hiddenPage,
      profileMap,
      respondedByData
    );
    const { submissionAction } = submissionConditionData;
    if (isValidated) {
      formSubmissionAction = submissionAction;
    }
  }

  const validatedData: IValidateFormRules = {
    fieldsToHideAndShow: {
      hide: hiddenField,
      show: visibleField,
      disabled: disabledFields,
    },
    pageToHideAndShow: {
      show: [],
      skip: hiddenPage,
      hide: [],
      elseSkip: [],
    },
    valuesToUpdate: valuesToUpdate,
    submissionAction: formSubmissionAction,
  };
  return validatedData;
};

export const generateNewFieldData = (
  fieldId: string,
  selectedFieldType: string
): IBaseFormField => {
  const updatedFieldData: IBaseFormField = {
    ...defaultFormFieldData,
    grid: {
      width: 6,
    },
    fieldType: selectedFieldType,
    localId: fieldId,
    isRequired: false,
  };

  switch (selectedFieldType) {
    case FormFieldTypes.DESCRIPTION:
      updatedFieldData.grid = {
        width: 12,
      };
      break;

    case FormFieldTypes.PAYMENT:
      updatedFieldData.isRequired = true;
      break;
    case FormFieldTypes.GEOLOCATION:
      updatedFieldData.fieldValue = {
        fetchIpAddress: false,
      };
      break;

    case FormFieldTypes.FILE_UPLOAD:
      updatedFieldData.fieldValue = {
        maxNumFiles: 10,
        maxFileSize: 12,
        imageHeight: "80",
        imageWidth: "80",
        isSpecificFileType: true,
        isImageViewEnable: false,
        isLogoUpload: false,
      };
      break;
    case FormFieldTypes.NUMBER_INPUT:
      updatedFieldData.fieldValue = {
        isNegativeAllowed: true,
        isDecimal: true,
        isIncrDecrEnabled: false,
        incrDecrType: "",
      };
      break;
    case FormFieldTypes.DATA_GRID:
      updatedFieldData.grid = {
        width: 12,
      };
      break;
  }

  return updatedFieldData;
};

export const handleUpdateFieldData = (
  value: any,
  key: commonFieldMapperData,
  fieldData: any
) => {
  let values = { ...fieldData };
  if (key == commonFieldMapperData.isRequired && value) {
    values = {
      ...fieldData,
      [key]: {
        initialValue: value,
      },
      [commonFieldMapperData.isVisible]: {
        initialValue: false,
      },
      [commonFieldMapperData.isDisabled]: {
        initialValue: false,
      },
    };
  } else if (key == commonFieldMapperData.isVisible && value) {
    values = {
      ...fieldData,
      [key]: {
        initialValue: value,
      },
      [commonFieldMapperData.isRequired]: {
        initialValue: false,
      },
      [commonFieldMapperData.isDisabled]: {
        initialValue: false,
      },
    };
  } else if (key == commonFieldMapperData.isDisabled && value) {
    values = {
      ...fieldData,
      [key]: {
        initialValue: value,
      },
      [commonFieldMapperData.isRequired]: {
        initialValue: false,
      },
      [commonFieldMapperData.isVisible]: {
        initialValue: false,
      },
    };
  } else {
    values = {
      ...fieldData,
      [key]: {
        initialValue: value,
      },
    };
  }
  return values;
};

export enum descriptionType {
  REGULAR = "REGULAR",
  TOOLTIP = "TOOLTIP",
}

export const valiDateWorkflow = (
  workflowServer: IWorkflowServer[],
  fieldSubmissionMap: IFieldSubmissionMap,
  activeFormData: IForm,
  currentEvent: Events,
  profileMap?: IProfileMap,
  respondedByData?: IRespondedBySubmissionMap,
  organizationAtribututes?: IAttribute,
  isDraftSumbission?: boolean
): IValidateFormRules => {
  const workflowList: IWorkflowServer[] = workflowServer || [];
  let hiddenField: string[] = [];
  let visibleField: string[] = [];
  let valuesToUpdate: ISetRuleValueActionFieldTypeServer[] = [];
  let disabledFields: string[] = [];
  let hiddenPage: string[] = [];
  let visblePage: string[] = [];
  let formSubmissionAction: ISubmissionLevelRuleActionServer = {};
  workflowList.forEach((workflowServer: IWorkflowServer) => {
    const eventType = workflowServer?.workflow?.eventData?.eventType;
    workflowServer;
    if (!workflowServer.isEnabled) {
      return;
    }
    if (isDraftSumbission && workflowServer.workflow.event === Events.EDITED) {
      return;
    }
    if (
      workflowServer.workflow.event != currentEvent &&
      workflowServer.workflow.event != Events.CREATEDEDITED
    ) {
      return;
    }

    if (
      workflowServer.workflow.eventCondition != "PRE_FORM_SUBMISSION" &&
      workflowServer.workflow.eventCondition != "ON_FORM_SUBMISSION"
    ) {
      return;
    }

    const fieldRules: IFieldLevelRuleServer[] =
      workflowServer.workflow.eventCondition == "PRE_FORM_SUBMISSION" &&
      eventType == "SET_FIELD_RULE" &&
      workflowServer?.workflow?.rules?.fieldRules
        ? workflowServer?.workflow?.rules?.fieldRules
        : [];
    const pageRules: IPageLevelRuleServer[] =
      workflowServer.workflow.eventCondition == "PRE_FORM_SUBMISSION" &&
      eventType == "SET_PAGE_RULE" &&
      workflowServer?.workflow?.rules?.pageRules
        ? workflowServer?.workflow?.rules?.pageRules
        : [];
    // workflowServer?.workflow?.rules?.pageRules || [];
    const submissionRules: ISubmissionLevelRuleServer[] =
      workflowServer.workflow.eventCondition == "ON_FORM_SUBMISSION" &&
      eventType == "VALIDATION_ON_FORM_SUBMISSION" &&
      workflowServer?.workflow?.rules?.submissionRules
        ? workflowServer?.workflow?.rules?.submissionRules
        : [];
    // workflowServer?.workflow?.rules?.submissionRules || [];
    runWorkflowScript(
      [workflowServer],
      scriptType?.ON_FORM_SUBMISSION_SCRIPT,
      fieldSubmissionMap
    );

    for (const index in fieldRules) {
      const fieldConditionData: IFieldLevelRuleServer = fieldRules[index];
      const isValidated: boolean = valiDateFieldRule(
        fieldConditionData,
        fieldSubmissionMap,
        hiddenField,
        profileMap,
        respondedByData,
        organizationAtribututes
      );
      const { action } = fieldConditionData;
      const hideField = action.hide ?? [];
      const showField = action.show ?? [];
      const setValue = action.setValue ?? [];
      const enable = action.enable ?? [];
      const disable = action.disable ?? [];
      const fieldsToHide = hideField.map((field) => field.fieldLocalId);
      const fieldsToshow = showField.map((field) => field.fieldLocalId);
      const fieldsToDisable = disable.map((field) => field.fieldLocalId);
      const fieldsToEnable = enable.map((field) => field.fieldLocalId);
      if (isValidated) {
        visibleField = [...visibleField, ...fieldsToshow]; // can be usedLater
        hiddenField = [...hiddenField, ...fieldsToHide];
        valuesToUpdate = [...valuesToUpdate, ...setValue];
        disabledFields = [...disabledFields, ...fieldsToDisable];
      } else {
        visibleField = [...visibleField, ...fieldsToHide]; // can be usedLater
        hiddenField = [...hiddenField, ...fieldsToshow];
        disabledFields = [...disabledFields, ...fieldsToEnable];
      }
    }
    for (const index in pageRules) {
      const pageConditionData: IPageLevelRuleServer = pageRules[index];
      const pageRuleValidationData = valiDatePageRule(
        pageConditionData,
        fieldSubmissionMap,
        _.cloneDeep(hiddenPage),
        visblePage,
        activeFormData,
        profileMap,
        respondedByData
      );
      const { isValidated, updatedHiddenPage, updatedVisiblePage } =
        pageRuleValidationData;
      const { action } = pageConditionData;
      const showPage = action.show ?? [];
      const pageToshow = showPage.map((page) => page.subFormLocalId);
      const elseSkip = action.elseSkip ?? [];
      const elseSkipPages = elseSkip.map((page) => page.subFormLocalId);
      if (isValidated) {
        hiddenPage = [...hiddenPage, ...updatedHiddenPage];
        visblePage = [...visblePage, ...updatedVisiblePage, ...pageToshow];
      } else {
        visblePage = [...visblePage, ...updatedHiddenPage];
        const activeCondition = pageConditionData?.conditions?.[0];
        const conditionSubFormId = activeCondition?.subFormLocalId || "";
        const elesSkipToPage = elseSkipPages?.[0] || "";
        const stopIndex = activeFormData?.subForms?.indexOf(elesSkipToPage);
        const startIndex =
          activeFormData?.subForms?.indexOf(conditionSubFormId) || 0;
        let resultArray = [];
        if (stopIndex !== -1) {
          resultArray = activeFormData?.subForms?.slice(
            startIndex + 1,
            stopIndex
          );
        }
        // hiddenPage = [...updatedHiddenPage, ...resultArray, ...pageToshow]; //COMMENTED SINCE ISSUES in hallbooking
      }
    }
    for (const index in submissionRules) {
      const submissionConditionData: ISubmissionLevelRuleServer =
        submissionRules[index];
      const isValidated: boolean = valiDateFieldRule(
        submissionConditionData,
        fieldSubmissionMap,
        hiddenPage,
        profileMap,
        respondedByData,
        organizationAtribututes
      );
      const { submissionAction } = submissionConditionData;
      if (isValidated) {
        const updatedSubmissionAction: ISubmissionLevelRuleActionServer =
          getUpdatedSubmissionAction(submissionAction, fieldSubmissionMap);
        formSubmissionAction = updatedSubmissionAction;
      }
    }
  });

  const validatedData: IValidateFormRules = {
    fieldsToHideAndShow: {
      hide: hiddenField,
      show: visibleField,
      disabled: disabledFields,
    },
    pageToHideAndShow: {
      show: visblePage,
      skip: hiddenPage,
      hide: hiddenPage,
      elseSkip: [],
    },
    valuesToUpdate: valuesToUpdate,
    submissionAction: formSubmissionAction,
  };
  return validatedData;
};

export enum scriptType {
  "FIELD_INPUT_SCRIPT" = "FIELD_INPUT_SCRIPT",
  "LOAD_FORM_SCRIPT" = "FIELD_INPUT_SCRIPT",
  "ON_FORM_SUBMISSION_SCRIPT" = "FIELD_INPUT_SCRIPT",
}

export const runWorkflowScript = (
  workflowList: IWorkflowServer[],
  type: scriptType,
  fieldSubmissionMap: IFieldSubmissionMap = {}
) => {
  workflowList.forEach((workflowServer: IWorkflowServer) => {
    switch (type) {
      case scriptType.FIELD_INPUT_SCRIPT:
        const fieldInputScript: IFieldInputscript =
          workflowServer?.workflow?.eventData?.fieldInputScript;
        const fieldId = fieldInputScript?.fieldId;
        const fieldData = fieldSubmissionMap[fieldId];
        if (fieldInputScript?.fieldId && fieldInputScript?.script) {
          const fieldValue = transformFieldSubmissionValuesClientToServer(
            fieldData?.fieldType,
            fieldData?.fieldSubmissionValue
          );
          const executableFieldInputScript = stringToExecutableFunction(
            updateFieldValue(fieldInputScript?.script, fieldValue)
          );
          executableFieldInputScript();
        }
        break;
      case scriptType.LOAD_FORM_SCRIPT:
        const loadFormScript: ILoadFormCustomScript =
          workflowServer?.workflow?.eventData?.loadFormScript;
        if (loadFormScript?.script) {
          const executableLoadFormScript = stringToExecutableFunction(
            loadFormScript?.script
          );
          executableLoadFormScript();
        }
        break;
      case scriptType.ON_FORM_SUBMISSION_SCRIPT:
        const onFormSubmissionCustomScript: IFormSubmissionCustomScript =
          workflowServer?.workflow?.eventData?.onFormSubmissionCustomScript;
        if (onFormSubmissionCustomScript?.script) {
          const executableOnFormSubmissionCustomScript =
            stringToExecutableFunction(onFormSubmissionCustomScript?.script);
          executableOnFormSubmissionCustomScript();
        }
        break;
      default:
        break;
    }
  });
};

const updateFieldValue = (value: string, fieldValue) => {
  return value?.replace("{{field_value}}", fieldValue);
};

export const handleUpdateDateRuleData = (
  value: any,
  key: string,
  fieldData: any
) => {
  let updatedValues = { ...fieldData };
  if (key == "dateRangeEnabled" && value) {
    updatedValues = {
      dateRangeEnabled: {
        initialValue: value,
      },
      specificDateSelectionEnabled: {
        initialValue: false,
      },
      specificDateRangeEnabled: {
        initialValue: false,
      },
      jsonApiEnabled: {
        initialValue: false,
      },
    };
  } else if (key == "specificDateSelectionEnabled" && value) {
    updatedValues = {
      dateRangeEnabled: {
        initialValue: false,
      },
      specificDateSelectionEnabled: {
        initialValue: value,
      },
      specificDateRangeEnabled: {
        initialValue: false,
      },
      jsonApiEnabled: {
        initialValue: false,
      },
    };
  } else if (key == "specificDateRangeEnabled" && value) {
    updatedValues = {
      // ...fieldData,
      dateRangeEnabled: {
        initialValue: false,
      },
      specificDateSelectionEnabled: {
        initialValue: false,
      },
      specificDateRangeEnabled: {
        initialValue: value,
      },
      jsonApiEnabled: {
        initialValue: false,
      },
    };
  } else if (key == "jsonApiEnabled" && value) {
    updatedValues = {
      // ...fieldData,
      dateRangeEnabled: {
        initialValue: false,
      },
      specificDateSelectionEnabled: {
        initialValue: false,
      },
      specificDateRangeEnabled: {
        initialValue: false,
      },
      jsonApiEnabled: {
        initialValue: value,
      },
    };
  }
  return updatedValues;
};
export const replaceFieldIdInText = (fieldId: string): string => {
  const updatedFieldId = `{{submission.${fieldId}}}`;
  return updatedFieldId;
  //text.replace(fieldId, updatedFieldId)
};
export const getUpdatedSubmissionAction = (
  submissionActionData: ISubmissionLevelRuleActionServer,
  fieldSubmissionMap: IFieldSubmissionMap
): ISubmissionLevelRuleActionServer => {
  let errorMessage = submissionActionData.value;
  const fieldIds: string[] = getFieldIds(errorMessage);
  for (const fieldId of fieldIds) {
    const submissionValue = getSubmissionValue(fieldSubmissionMap, fieldId);
    const replacingText = replaceFieldIdInText(fieldId);
    errorMessage = errorMessage.replace(replacingText, submissionValue);
  }
  return {
    actionType: submissionActionData.actionType,
    value: errorMessage,
  };
};
export const getSubmissionValue = (
  fieldSubmissionMap: IFieldSubmissionMap,
  fieldId: string
) => {
  const fieldType = fieldSubmissionMap[fieldId]?.fieldType;
  const fieldValueSubmissionData: IFormFieldSubmission =
    fieldSubmissionMap[fieldId];
  const fieldValueSubmissionValue =
    fieldValueSubmissionData?.fieldSubmissionValue;
  let updatedValue: any = "";
  switch (fieldType) {
    case FormFieldTypes?.DROPDOWN:
      if (fieldValueSubmissionValue?.selectedOption) {
        updatedValue = fieldValueSubmissionValue?.selectedOption;
      }
      if (fieldValueSubmissionValue?.selectedOptions) {
        updatedValue = fieldValueSubmissionValue?.selectedOptions;
      }
      break;
    case FormFieldTypes?.MULTIPLE_CHOICES:
      if (fieldValueSubmissionValue?.selectedOption) {
        updatedValue = fieldValueSubmissionValue?.selectedOption;
      }
      if (fieldValueSubmissionValue?.selectedOptions) {
        updatedValue = fieldValueSubmissionValue?.selectedOptions;
      }
      break;
    case FormFieldTypes?.LINEAR_SCALING:
      updatedValue = fieldValueSubmissionValue?.selectedOption + "";
      break;
    case FormFieldTypes?.FILE_UPLOAD:
      updatedValue = fieldValueSubmissionValue?.uploadedFiles;
      break;
    case FormFieldTypes?.RATING:
      updatedValue = fieldValueSubmissionValue?.selectedOption + "";
      break;
    default:
      updatedValue = fieldValueSubmissionValue?.value;
      break;
  }
  return updatedValue;
};
export const getFieldIds = (submissionMessage: string) => {
  const regex: RegExp = /{{submission\.(.*?)}}/g;
  const fieldIds: string[] = [];
  let match: RegExpExecArray | null;

  while ((match = regex.exec(submissionMessage)) !== null) {
    fieldIds.push(match[1]);
  }
  return fieldIds;
};
